import { render } from "./thicknessPart.vue?vue&type=template&id=bfc5ed2a&scoped=true"
import script from "./thicknessPart.vue?vue&type=script&lang=js"
export * from "./thicknessPart.vue?vue&type=script&lang=js"

import "./thicknessPart.vue?vue&type=style&index=0&id=bfc5ed2a&lang=less&scoped=true"

import exportComponent from "E:\\project\\eyes-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc5ed2a"]])

export default __exports__